import { FormElement } from '@gearbelt/global';

import { getElementConfigSummary } from './element-config-summary.util';

export function ElementConfigSummary({ element }: { element: FormElement }) {
  const lines = getElementConfigSummary(element);
  if (lines.length === 0) {
    return null;
  }
  return (
    <div className="text-secondary-text bg-grey-1 mt-2 rounded-md p-2 text-xs">
      <div className="mb-0.5 font-medium">Config</div>
      {lines.map((line) => (
        <div key={line.label}>
          {line.label}: {line.value}
        </div>
      ))}
    </div>
  );
}
